import { BookText, MessageCircle, Sparkles } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

const PostLessonInvitation = ({ language = 'es', lessonId, lessonTitle }) => {
  const navigate = useNavigate();

  const t = (es, ca) => language === 'ca' ? ca : es;

  const handleChatWithContext = () => {
    // Navigate to chat with lesson context
    const titlePreview = lessonTitle ? lessonTitle.substring(0, 50) : '';
    navigate(`/chat?context=lesson&id=${lessonId}&title=${encodeURIComponent(titlePreview)}`);
  };

  return (
    <div className="mt-12 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <Sparkles className="w-5 h-5 text-purple-300" style={{ filter: 'drop-shadow(0 0 4px rgba(183, 148, 244, 0.4))' }} />
        <h3 className="text-lg font-medium text-purple-300">
          {t("Profundiza en tu aprendizaje", "Aprofundeix en el teu aprenentatge")}
        </h3>
      </div>

      <p className="text-gray-400 mb-6 leading-relaxed text-sm">
        {t(
          "Has completado esta lección. Ahora es el momento de integrar lo aprendido:",
          "Has completat aquesta lliçó. Ara és el moment d'integrar l'après:"
        )}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Diari - WITH MORE ELEGANT GLOW */}
        <button
          onClick={() => navigate('/journal')}
          className="group p-6 rounded-xl bg-purple-900/20 border border-purple-400/25 hover:border-purple-400/45 hover:bg-purple-900/30 transition-all duration-300"
          style={{ boxShadow: '0 0 16px rgba(183, 148, 244, 0.15)' }}
        >
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform" style={{ boxShadow: '0 0 16px rgba(183, 148, 244, 0.4)' }}>
              <BookText className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <h4 className="text-base font-medium text-purple-200 mb-2">
                {t("Escribe en tu Diario", "Escriu al teu Diari")}
              </h4>
              <p className="text-sm text-gray-400 leading-relaxed">
                {t(
                  "Reflexiona sobre lo que esta lección te ha removido. Escribe tus pensamientos, emociones y aprendizajes.",
                  "Reflexiona sobre el que aquesta lliçó t'ha remogut. Escriu els teus pensaments, emocions i aprenentatges."
                )}
              </p>
            </div>
          </div>
        </button>

        {/* IA Chat - WITH LESSON CONTEXT */}
        <button
          data-testid="chat-with-lesson-context-btn"
          onClick={handleChatWithContext}
          className="group p-6 rounded-xl bg-purple-900/20 border border-purple-400/25 hover:border-purple-400/45 hover:bg-purple-900/30 transition-all duration-300"
          style={{ boxShadow: '0 0 16px rgba(183, 148, 244, 0.15)' }}
        >
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform" style={{ boxShadow: '0 0 16px rgba(183, 148, 244, 0.4)' }}>
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <h4 className="text-base font-medium text-purple-200 mb-2">
                {t("Conversa amb la IA", "Conversa amb la IA")}
              </h4>
              <p className="text-sm text-gray-400 leading-relaxed">
                {t(
                  "Comparte tus reflexiones y dudas para una lectura ampliada y personalizada de la lección.",
                  "Comparteix les teves reflexions i dubtes per una lectura ampliada i personalitzada de la lliçó."
                )}
              </p>
            </div>
          </div>
        </button>
      </div>

      <p className="text-center text-purple-300/70 text-sm mt-6 italic">
        {t(
          "La transformación real sucede cuando llevas la teoría a la práctica",
          "La transformació real succeeix quan portes la teoria a la pràctica"
        )}
      </p>
    </div>
  );
};

export default PostLessonInvitation;
